import React, { Component, Fragment } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { debounce } from "lodash";
import { Toastr, Button } from "@revvsales/components";

import { ReactSelect, SearchableSelect } from "../../../commonComponents";

import { UserActions } from "../../../actions";
import { shareOppoService } from "../../../actions/PipelineActions/pipelineServices";

import { GlobalUtils } from "../../../utils";

// Destructuring
const { handleApiErrMsg, readDataFromLocalStorage } = GlobalUtils;
const { loadOwnerData } = UserActions;
const accessLevels = ["View", "Edit"];

// Decalaration
const DEBOUNCE_WAIT_TIME = 300;

class InviteSection extends Component {
  state = { shareWith: [], showSelector: true, users: [] };

  _updateShareAccess = (person, access) => {
    const data = [...this.state.shareWith];
    const index = data.findIndex(item => item.name === person);

    if (index >= 0) {
      data[index].currentAccess = access;
      this.setState({ shareWith: data });
    }
  };

  _handleChangeInSelect = value => {
    const person = {
      id: value.id,
      name: value.name,
      currentAccess: "View",
    };
    this.setState(prevState => ({
      shareWith: [...prevState.shareWith, person],
    }));
    this.setState({ showSelector: false });
  };

  _removeSelectedUser = id => {
    const shareList = [...this.state.shareWith];
    const newShareList = shareList.filter(item => item.id !== id);
    if (newShareList.length === 0) {
      this.setState({ showSelector: true });
    }
    this.setState({ shareWith: newShareList });
  };

  _getOptions = async (inputValue, callback) => {
    if (inputValue) {
      let result = [];
      await loadOwnerData(inputValue).then(data => {
        result = data.users;
      });
      this.setState({ users: result }, () => {
        const filteredOptions = this._filterUsersForOptions(this.state.users);
        return callback(filteredOptions);
      });
    }

    return callback([]);
  };

  _filterUsersForOptions = users => {
    let result = [];
    if (users && users.length > 0) {
      result = users.filter(resultItem => {
        const matchWithAlreadyShared = this.props.list.find(
          listitem => listitem.User.id === resultItem.id,
        );
        const matchWithToBeShared = this.state.shareWith.find(
          shareWithItem => shareWithItem.id === resultItem.id,
        );
        const resultItemIsLoggedIn =
          readDataFromLocalStorage("revvsalesUser").id === resultItem.id;
        const resultItemIsOppoOwner =
          this.props.oppo.owner.id === resultItem.id;
        if (
          matchWithAlreadyShared ||
          matchWithToBeShared ||
          resultItemIsLoggedIn ||
          resultItemIsOppoOwner
        ) {
          return false;
        }
        return true;
      });
    }
    return result;
  };

  _share = () => {
    const payload = this.state.shareWith.map(item => {
      const person = {
        user: { id: item.id },
        object_type: "OPP",
        object_id: this.props.oppo.id,
        sharing_method: "EXPLICIT",
        shared_until: "2019-12-20T14:37:12.995319+05:30",
        share: false,
        read: true,
      };
      if (item.currentAccess === "View") {
        person.write = false;
      } else if (item.currentAccess === "Edit") {
        person.write = true;
      }
      return person;
    });
    shareOppoService(payload)
      .then(() => {
        this.props.fetchOppoAccess(this.props.oppo.id);
        this.setState({ shareWith: [], showSelector: true });
        Toastr.showToastr({
          type: "success",
          message: "Opportunity has been shared successfully.",
          timeout: 2000,
        });
      })
      .catch(err => {
        Toastr.showToastr({
          type: "failure",
          message: handleApiErrMsg(err),
          timeout: 3000,
        });
      });
  };

  render() {
    const { shareWith, showSelector } = this.state;
    const getOptions = debounce(this._getOptions, DEBOUNCE_WAIT_TIME);
    return (
      <Fragment>
        <div className="oppo-sharing-invite-box">
          <div className="oppo-share-access-listing-title">Invite People:</div>
          {shareWith.map(people => (
            <div className="oppo-sharing-invite-box-selected">
              <span className="oppo-sharing-invite-box-selected-name">
                {people.name}
              </span>
              <span className="oppo-sharing-invite-box-selected-access">
                <ReactSelect
                  onChange={value =>
                    this._updateShareAccess(people.name, value.value)
                  }
                  options={accessLevels}
                  value={people.currentAccess}
                  valueKey="currentAccess"
                  labelKey="label"
                  data-test="invitesection-select"
                />
                <span className="btn-icon oppo-sharing-invite-box-selected-delete">
                  <span
                    className="btn-icon"
                    onClick={() => this._removeSelectedUser(people.id)}
                    onKeyPress={() => this._removeSelectedUser(people.id)}
                    role="button"
                    tabIndex="0">
                    <FontAwesomeIcon icon={["far", "times"]} />
                  </span>
                </span>
              </span>
            </div>
          ))}
          {showSelector && (
            <div className="oppo-sharing-invite-box-selection">
              <SearchableSelect
                getOptionLabel={({ name }) => name}
                promiseOption={getOptions}
                value={this.props.ownerFilters}
                _handleChangeInSelect={this._handleChangeInSelect}
                placeholder="Search users..."
                autoFocus
              />
              <span className="oppo-sharing-invite-box-select-access">
                <ReactSelect
                  onChange={value => this._updateShareAccess(value.value)}
                  options={accessLevels}
                  value={
                    (shareWith.length > 0 &&
                      shareWith[shareWith.length - 1].currentAccess) ||
                    "View"
                  }
                  valueKey="currentAccess"
                  labelKey="label"
                  data-test="invitesection-updateshareaccess-select"
                />
                <span>&nbsp;</span>
              </span>
            </div>
          )}
          {!showSelector && (
            <span
              className="revv-btn  revv-btn-secondary-sm"
              onClick={() => this.setState({ showSelector: true })}
              onKeyPress={() => this.setState({ showSelector: true })}
              role="button"
              tabIndex="0">
              <i>
                <FontAwesomeIcon icon={["far", "plus"]} />
              </i>
              Add Another User
            </span>
          )}
          {shareWith.length > 0 && (
            <div className="row">
              <div className="createquotepopup-footer oppo-share-btn-box">
                <div className="footer-actions">
                  <Button
                    className="btn btn-primary"
                    onClick={() => this._share()}
                    data-test="invitesection-btn">
                    INVITE
                  </Button>
                </div>
              </div>
            </div>
          )}
        </div>
      </Fragment>
    );
  }
}

export default InviteSection;



// WEBPACK FOOTER //
// ./src/components/PipelineWrapper/OppoSharingPopup/InviteSection.js